import {
  ImageBackground,
  Image,
  StyleSheet,
  useWindowDimensions,
  SafeAreaView,
  TouchableOpacity,
  Animated,
  Platform,
  Modal,
} from "react-native";
import React, { useState } from "react";
import { TabView, SceneMap, TabBar } from "react-native-tab-view";
import {
  Text,
  View,
  Box,
  Center,
  ScrollView,
  Flex,
  HStack,
  VStack,
  Heading,
  Pressable,
  IconButton,
  Button,
} from "native-base";
import { LinearGradient } from "expo-linear-gradient";
import ImageViewer from "react-native-image-zoom-viewer";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { StackScreenProps } from "../types";

const TEAM_ABUJA = require("../assets/team_abuja.png");
const TEAM_LAGOS = require("../assets/team_lagos.png");
const TEAM_KENYA = require("../assets/team_kenya.png");

const images = [
  {
    url: TEAM_ABUJA,
  },
  {
    url: TEAM_LAGOS,
  },
  {
    url: TEAM_KENYA,
  },
];

const FirstRoute = () => {
  // const { width, height } = useWindowDimensions();
  const [visible, setIsVisible] = useState(false);

  return (
    <ScrollView
      contentContainerStyle={{
        marginTop: 50,
        flex: 1,
        justifyContent: "space-between",
      }}
    >
      <Pressable
        w="5/6"
        h="1/2"
        marginX="auto"
        mb={5}
        onPress={() => setIsVisible(true)}
      >
        <ImageBackground
          source={TEAM_LAGOS}
          style={{
            width: "100%",
            height: "100%",
            borderRadius: 15,
            overflow: "hidden",
            borderWidth: 2,
            borderColor: "white",
          }}
          imageStyle={{
            borderRadius: 15,
            backgroundColor: "rgba(0,0,0,.8)",
          }}
        ></ImageBackground>
      </Pressable>

      <Modal visible={visible} transparent={true}>
        <ImageViewer
          imageUrls={images}
          index={1}
          enableSwipeDown={true}
          onSwipeDown={() => setIsVisible(false)}
          renderHeader={() => (
            <HStack
              alignItems={"center"}
              justifyContent={"flex-end"}
              paddingX={10}
              paddingY={15}
            >
              <IconButton
                icon={
                  <MaterialCommunityIcons name="close" color="#fff" size={22} />
                }
                onPress={() => setIsVisible(false)}
              />
            </HStack>
          )}
        />
      </Modal>

      {/* <BottomSlidingImages /> */}
    </ScrollView>
  );
};

const SecondRoute = () => {
  const [visible, setIsVisible] = useState(false);

  return (
    <ScrollView
      contentContainerStyle={{
        marginTop: 50,
        flex: 1,
        justifyContent: "space-between",
      }}
    >
      <Pressable
        w="5/6"
        h="1/2"
        marginX="auto"
        mb={5}
        onPress={() => setIsVisible(true)}
      >
        <ImageBackground
          source={TEAM_ABUJA}
          style={{
            width: "100%",
            height: "100%",
            borderRadius: 15,
            overflow: "hidden",
            borderWidth: 2,
            borderColor: "white",
          }}
          imageStyle={{
            borderRadius: 15,
            backgroundColor: "rgba(0,0,0,.8)",
          }}
        ></ImageBackground>
      </Pressable>

      <Modal visible={visible} transparent={true}>
        <ImageViewer
          imageUrls={images}
          index={0}
          enableSwipeDown={true}
          onSwipeDown={() => setIsVisible(false)}
          renderHeader={() => (
            <HStack
              alignItems={"center"}
              justifyContent={"flex-end"}
              paddingX={10}
              paddingY={15}
            >
              <IconButton
                icon={
                  <MaterialCommunityIcons name="close" color="#fff" size={22} />
                }
                onPress={() => setIsVisible(false)}
              />
            </HStack>
          )}
        />
      </Modal>

      {/* <BottomSlidingImages /> */}
    </ScrollView>
  );
};

const ThirdRoute = () => {
  const [visible, setIsVisible] = useState(false);

  return (
    <ScrollView
      contentContainerStyle={{
        marginTop: 50,
        flex: 1,
        justifyContent: "space-between",
      }}
    >
      <Pressable
        w="5/6"
        h="1/2"
        marginX="auto"
        mb={5}
        onPress={() => setIsVisible(true)}
      >
        <ImageBackground
          source={TEAM_KENYA}
          style={{
            width: "100%",
            height: "100%",
            borderRadius: 15,
            overflow: "hidden",
            borderWidth: 2,
            borderColor: "white",
          }}
          imageStyle={{
            borderRadius: 15,
            backgroundColor: "rgba(0,0,0,.8)",
          }}
        ></ImageBackground>
      </Pressable>

      <Modal visible={visible} transparent={true}>
        <ImageViewer
          imageUrls={images}
          index={2}
          enableSwipeDown={true}
          onSwipeDown={() => setIsVisible(false)}
          renderHeader={() => (
            <HStack
              alignItems={"center"}
              justifyContent={"flex-end"}
              paddingX={10}
              paddingY={15}
            >
              <IconButton
                icon={
                  <MaterialCommunityIcons name="close" color="#fff" size={22} />
                }
                onPress={() => setIsVisible(false)}
              />
            </HStack>
          )}
        />
      </Modal>

      {/* <BottomSlidingImages /> */}
    </ScrollView>
  );
};

const renderScene = SceneMap({
  first: FirstRoute,
  second: SecondRoute,
  third: ThirdRoute,
});

type Route = { key: string; title: string };

const Team = ({ navigation }: StackScreenProps<"Team">) => {
  const { width, height } = useWindowDimensions();

  const [index, setIndex] = React.useState(0);
  const [routes] = React.useState([
    { key: "first", title: "OCP Africa Lagos" },
    { key: "second", title: "OCP Africa Abuja" },
    { key: "third", title: "OCP Africa Kenya" },
  ]);

  const renderTabBar = (props: any) => {
    const inputRange = props.navigationState.routes.map(
      (x: any, i: number) => i
    );

    return (
      <Flex
        direction="row"
        // borderBottomColor="rgba(21, 69, 126, 1)"
        borderColor="#fff"
        borderWidth={1}
        marginX={15}
        borderRadius={15}
        mx={"16"}
      >
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={{
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          {props.navigationState.routes.map((route: Route, i: number) => {
            const opacity = props.position.interpolate({
              inputRange,
              outputRange: inputRange.map((inputIndex: number) =>
                inputIndex === i ? 1 : 0.5
              ),
            });

            return (
              <TouchableOpacity
                style={styles.tabItem}
                onPress={() => setIndex(i)}
              >
                <Animated.Text
                  style={{
                    opacity,
                    color:
                      props.navigationState.index == i ? "#ffffff" : "#84aad9",
                  }}
                >
                  {route.title}
                </Animated.Text>
              </TouchableOpacity>
            );
          })}
        </ScrollView>
      </Flex>
    );
  };

  return (
    <ImageBackground
      source={require("../assets/background.png")}
      resizeMode="cover"
      style={{ width, height }}
    >
      {/* <View style={styles.overlay}> */}
      <LinearGradient
        colors={[
          "rgba(11, 46, 89, 1)",
          "rgba(0, 0, 0, 1)",
          "rgba(41, 124, 224, 1)",
        ]}
        style={styles.overlay}
      >
        <SafeAreaView style={{ height }}>
          <HStack
            mb={5}
            px={10}
            mt={Platform.OS == "web" ? "20" : "5"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            {/* <Button
              startIcon={
                <MaterialCommunityIcons name="arrow-left" color={"#fff"} />
              }
              // position={"absolute"}
              onPress={() => navigation.navigate("Home")}
              // left={0}
              // top={-5}
              variant={"ghost"}
            >
              Back
            </Button> */}

            <Pressable
              // flex={1}
              flexDir={"row"}
              alignItems={"center"}
              onPress={() => navigation.navigate("Home")}
            >
              <Text fontSize={17}> ←</Text>
              <Heading textAlign="center">The team</Heading>
            </Pressable>
          </HStack>

          <TabView
            navigationState={{ index, routes }}
            renderScene={renderScene}
            onIndexChange={setIndex}
            initialLayout={{ width }}
            renderTabBar={renderTabBar}
          />
        </SafeAreaView>
      </LinearGradient>
    </ImageBackground>
  );
};

export default Team;

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    // backgroundColor: "rgba(110, 178, 69, 0.8)",
  },
  cardOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  },
  tabBar: {
    flexDirection: "row",
    paddingTop: 20,
  },
  tabItem: {
    flex: 1,
    alignItems: "center",
    padding: 16,
  },
});
